import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
import { showTitle as _showTitle } from '@/libs/util';
import CommonIcon from '_c/common-icon';
import './custom-bread-crumb.less';
export default {
  name: 'customBreadCrumb',
  components: {
    CommonIcon: CommonIcon
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fontSize: {
      type: Number,
      default: 14
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showTitle: function showTitle(item) {
      return _showTitle(item, this);
    },
    isCustomIcon: function isCustomIcon(iconName) {
      return iconName.indexOf('_') === 0;
    },
    getCustomIconName: function getCustomIconName(iconName) {
      return iconName.slice(1);
    }
  }
};